"use strict";
/* eslint-disable no-param-reassign */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
const lodash_1 = __importDefault(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
exports.concentrationLimitPointerMethods = [
    {
        method: 'viablyViola1.avgReceivableOutstanding',
        pointerImplementation: ({ concentrationReceivables, valueConfig }) => {
            const concentrationLimit = valueConfig.limit;
            const groupByFieldType = 'string';
            const groupingField = 'org_id';
            const method = 'viablyViola1.avgReceivableOutstanding';
            concentrationReceivables.forEach((rec) => {
                (0, common_1.finleyAssert)(typeof rec.baseFields[groupingField] === groupByFieldType, `baseFields.${groupingField} must be defined to run ${method}. Found [${rec.baseFields[groupingField]}}]`);
            });
            const grouped = lodash_1.default.groupBy(concentrationReceivables, (rec) => rec.baseFields[groupingField]);
            let totalExposure = 0;
            let totalGroups = 0;
            const totalExposureByGroup = new Map();
            // kick out any groups that have zero exposure.
            lodash_1.default.forEach(lodash_1.default.toPairs(grouped), ([group, receivables]) => {
                const groupExposure = lodash_1.default.sumBy(receivables, (rec) => rec.concentrationLimitFields
                    .eligibleExposureLessConcentrationLimitKickouts);
                if (groupExposure !== 0) {
                    // we only want to consider groups that have some exposure.
                    totalExposureByGroup.set(group, groupExposure);
                    totalExposure += groupExposure;
                    // eslint-disable-next-line no-plusplus
                    totalGroups++;
                }
                else {
                    // remove the group that we do not care about.
                    delete grouped[group];
                }
            });
            // find average of total exposure amoung gropups
            const maxAverage = concentrationLimit;
            const maxExposure = maxAverage * totalGroups;
            const receivables = lodash_1.default.flatten(lodash_1.default.values(grouped));
            // now we want to make sure that exposure is not greater than max exposure.
            return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                concentrationLimit: maxExposure,
                totalConcentrationExposure: totalExposure,
                concentrationReceivables: receivables,
                concentrationLimitValueType: 'number',
            });
            // we can also use weighted average.
            // but that kicks out whole receivable, thus may exceed
            // kickouts. (@callie wants standard)
            // return calculateWeightedAverageConcentrationLimitKickouts({
            //   concentrationLimit: maxExposure,
            //   field:
            //     'concentrationLimitFields.eligibleExposureLessConcentrationLimitKickouts',
            //   concentrationReceivables: receivables,
            //   limitType: 'max',
            //   weighting: 'constant',
            // });
        },
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map